<div class="row mt-3 mb-5 mx-3 mx-md-0">
  <div class="col-12 col-md-10 offset-md-1 justify-content-center">
    <mat-card class="rounded-0 border p-md-3 p-1">
      <mat-card-title>
        <button
          mat-mini-fab
          color="primary"
          class="mt-n3 mb-3"
          [routerLink]="['/cotizaciones']"
          matTooltip="Regresar"
          matTooltipPosition="right"
        >
          <mat-icon>arrow_back</mat-icon>
        </button>

        <h2 class="color-blue-cat">Editar cotización</h2>
        
      </mat-card-title>

      <app-form-cotizaciones></app-form-cotizaciones>

    </mat-card>
  </div>
</div>


